import { Sparkle20Regular } from '@/components/Icon'

export const DEFAULT_ASK_BAR_AI_MODEL_ID = 'auto'

/** @type {{ value: string, label: string, Icon: import('react').ComponentType }[]} */
export const HOME_AI_MODEL_SELECT_OPTIONS = [
  { value: 'auto', label: 'Auto', description: 'Choose the recommended model for this chat', Icon: Sparkle20Regular },
  { value: 'openai:gpt-4.1-mini', label: 'Basic', description: 'Fast and cost-effective for frequent tasks', Icon: Sparkle20Regular },
  { value: 'openai:gpt-4.1', label: 'Advanced', description: 'Balanced thinking for most tasks', Icon: Sparkle20Regular },
  { value: 'anthropic:claude-sonnet', label: 'Expert', description: 'Deep reasoning for complex tasks', Icon: Sparkle20Regular },
  { value: 'gemini:gemini-pro', label: 'Genius', description: 'Extended reasoning for the hardest tasks', Icon: Sparkle20Regular },
]

export const SPECIFIC_MODEL_OPTIONS = [
  { value: 'openai:gpt-4.1-mini', label: 'GPT-4.1 Mini', provider: 'OpenAI', Icon: Sparkle20Regular },
  { value: 'openai:gpt-4.1', label: 'GPT-4.1', provider: 'OpenAI', Icon: Sparkle20Regular },
  { value: 'anthropic:claude-haiku', label: 'Claude Haiku', provider: 'Anthropic', Icon: Sparkle20Regular },
  { value: 'anthropic:claude-sonnet', label: 'Claude Sonnet', provider: 'Anthropic', Icon: Sparkle20Regular },
  { value: 'gemini:gemini-flash', label: 'Gemini Flash', provider: 'Google', Icon: Sparkle20Regular },
  { value: 'gemini:gemini-pro', label: 'Gemini Pro', provider: 'Google', Icon: Sparkle20Regular },
  { value: 'xai:grok-1', label: 'Grok 1', provider: 'xAI', Icon: Sparkle20Regular },
  { value: 'xai:grok-2', label: 'Grok 2', provider: 'xAI', Icon: Sparkle20Regular },
  { value: 'dochat:base', label: 'Do Chat Base', provider: 'DO Chat', Icon: Sparkle20Regular },
  { value: 'dochat:pro', label: 'Do Chat Pro', provider: 'DO Chat', Icon: Sparkle20Regular },
]
